import { ClientModelInput, ClientModelVariable } from "@services/api/types";

export interface IVariableValues {
  // timePeriod: { modelVarId: value }
  [key: string]: { [key: number]: number };
}

export const getExternalVarsPredefinedValues = (
  inputs: ClientModelInput[]
): { [key: string]: { [key: string]: number } } => {
  const varValuePeriod: { [key: string]: { [key: string]: number } } = {};
  inputs.forEach((varInput) => {
    if (!(varInput.time_period in varValuePeriod)) {
      varValuePeriod[varInput.time_period] = {};
    }
    varValuePeriod[varInput.time_period][varInput.name] = varInput.value;
  });
  return varValuePeriod;
};

export const getExternalEffectsValues = (
  timePeriods: string[],
  variableValues: IVariableValues,
  predefinedValues: { [key: string]: { [key: string]: number } },
  modelVars?: ClientModelVariable[]
) => {
  const values: {
    [key: string]: { [key: number]: number };
  } = {};

  timePeriods.forEach((timePeriod) => {
    values[timePeriod] = {};
    (modelVars || []).forEach((modelVar) => {
      let modelPeriodValue = 0;
      if (
        timePeriod in variableValues &&
        modelVar.id in variableValues[timePeriod]
      ) {
        modelPeriodValue = variableValues[timePeriod][modelVar.id];
      } else if (
        timePeriod in predefinedValues &&
        modelVar.name in predefinedValues[timePeriod]
      ) {
        modelPeriodValue = predefinedValues[timePeriod][modelVar.name];
      }
      values[timePeriod][modelVar.id] = modelPeriodValue;
    });
  });

  return values;
};

export const externalEffectsToClientInputs = (
  modelId: number,
  externalEffects: IVariableValues,
  modelVars: ClientModelVariable[]
): ClientModelInput[] => {
  const modelVarIdMapping = modelVars.reduce(
    (acc, modelVar) => {
      acc[modelVar.id] = modelVar.name;
      return acc;
    },
    {} as { [key: number]: string }
  );

  const clientInputs: ClientModelInput[] = [];
  Object.keys(externalEffects).forEach((timePeriod) =>
    Object.keys(externalEffects[timePeriod]).forEach((modelVarId) => {
      const modelVarIdNumber = Number(modelVarId);
      clientInputs.push({
        model_id: modelId,
        name: modelVarIdMapping[modelVarIdNumber] || "",
        time_period: timePeriod,
        value: externalEffects[timePeriod][modelVarIdNumber]
      });
    })
  );
  return clientInputs;
};
